function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "surround",
  d: "M1 8C1 8 3.54547 3 8.00004 3C12.4546 3 15.0001 8 15.0001 8C15.0001 8 12.4546 13 8.00004 13C3.54547 13 1 8 1 8Z",
  fill: "#0A648F",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "iris",
  d: "M8.00012 10.0909C9.10469 10.0909 10.0001 9.19551 10.0001 8.09094C10.0001 6.98637 9.10469 6.09094 8.00012 6.09094C6.89555 6.09094 6.00012 6.98637 6.00012 8.09094C6.00012 9.19551 6.89555 10.0909 8.00012 10.0909Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgEyeOff = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEyeOff, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye-off.0d6aad87.svg";
export { ForwardRef as ReactComponent };